/**
 * BackgroundAnimation component - Animated SVG background with orange to yellow gradients
 * Constitutional requirement: React with regular JavaScript
 */

import React from 'react'

import '../background.css'

const BackgroundAnimation = () => {
  return (
    <div className="background-animation-container">
      <svg className="background-svg" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1200 800" preserveAspectRatio="xMidYMid slice">
        <defs>
          {/* Orange to Yellow Gradients */}
          <linearGradient id="orangeYellow1" x1="0%" y1="0%" x2="100%" y2="100%">
            <stop offset="0%" stopColor="#ff6b35" stopOpacity="0.12" />
            <stop offset="50%" stopColor="#ff8c42" stopOpacity="0.08" />
            <stop offset="100%" stopColor="#ffc107" stopOpacity="0.04" />
          </linearGradient>
          
          <linearGradient id="orangeYellow2" x1="100%" y1="0%" x2="0%" y2="100%">
            <stop offset="0%" stopColor="#ffc107" stopOpacity="0.10" />
            <stop offset="50%" stopColor="#ff8c42" stopOpacity="0.06" />
            <stop offset="100%" stopColor="#ff6b35" stopOpacity="0.02" />
          </linearGradient>
          
          <linearGradient id="orangeYellow3" x1="0%" y1="100%" x2="100%" y2="0%">
            <stop offset="0%" stopColor="#ff6b35" stopOpacity="0.06" />
            <stop offset="100%" stopColor="#ffc107" stopOpacity="0.09" />
          </linearGradient>
          
          <linearGradient id="accent1" x1="0%" y1="50%" x2="100%" y2="50%">
            <stop offset="0%" stopColor="#ff6b35" stopOpacity="0.15" />
            <stop offset="100%" stopColor="#ffc107" stopOpacity="0.08" />
          </linearGradient>
        </defs>
        
        {/* Floating curved background shapes */}
        <path 
          className="floating-line floating-line-1"
          d="M-100,150 Q200,80 500,140 T900,120 L1300,130 L1300,-50 L-100,-50 Z" 
          fill="url(#orangeYellow1)"
        />
        
        <path 
          className="floating-line floating-line-2"
          d="M-100,350 Q300,280 600,340 T1100,320 L1300,350 L1300,200 L-100,200 Z" 
          fill="url(#orangeYellow2)"
        />
        
        <path 
          className="floating-line floating-line-3"
          d="M-100,650 Q400,580 700,620 T1300,580 L1300,850 L-100,850 Z" 
          fill="url(#orangeYellow3)"
        />
        
        {/* Dynamic accent lines */}
        <line className="accent-line accent-line-1" x1="0" y1="100" x2="1200" y2="180" stroke="url(#accent1)" strokeWidth="2" />
        <line className="accent-line accent-line-2" x1="0" y1="600" x2="1200" y2="680" stroke="url(#orangeYellow2)" strokeWidth="1.5" />
        <line className="accent-line accent-line-3" x1="200" y1="0" x2="800" y2="800" stroke="url(#orangeYellow3)" strokeWidth="1" />
        
        {/* Animated circles */}
        <circle className="floating-circle floating-circle-1" cx="150" cy="250" r="4" fill="url(#orangeYellow1)" />
        <circle className="floating-circle floating-circle-2" cx="1000" cy="150" r="3" fill="url(#orangeYellow2)" />
        <circle className="floating-circle floating-circle-3" cx="200" cy="650" r="3.5" fill="url(#orangeYellow3)" />
        <circle className="floating-circle floating-circle-4" cx="1100" cy="550" r="2.5" fill="url(#accent1)" />
      </svg>
    </div>
  )
}

export default BackgroundAnimation
